import React from "react";
import { gql } from "apollo-boost";
import { useQuery } from "@apollo/react-hooks";
import ActiveFilterItem from "./ActiveFilterItem";

export const GET_SEASON = gql`
  query Seasons($id_list: [Int]) {
    seasons(id_list: $id_list) {
      _id
      name
    }
  }
`;

const ActiveFilterSeason = ({ IdList, removeAction, change }) => {
  const { data, loading, error } = useQuery(GET_SEASON, {
    variables: {
      id_list: IdList
    }
  });

  if (error) return "error";
  if (loading) return "";

  return (
    <>
      {data.seasons.map(it => (
        <ActiveFilterItem
          key={it._id}
          label={it.name}
          type={"REMOVE_SEASON"}
          payload={it._id}
          remove={removeAction}
          change={change}
        ></ActiveFilterItem>
      ))}
    </>
  );
};

export default ActiveFilterSeason;
